import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateLastSeenUserNotificationRequestParams {
  id: string;
}

export class UpdateLastSeenUserNotificationRequest extends Request<IUpdateLastSeenUserNotificationRequestParams, {}> {
  constructor(lastSeenUserNotificationId: string) {
    super('updateLastSeenUserNotification', {id: lastSeenUserNotificationId});
  }
}
